export class CommonBaseData{

  public rtnCode: string;

  public messageId: string;

  public messageList: Array<string>;

  public updateNo: number; 

  // ST-160(グループ区分個別の非稼働メッセージ表示対応) DEL START
  //public closeTimeMessage: string;
  // ST-160(グループ区分個別の非稼働メッセージ表示対応) DEL END

  // ST-158(業務時間外メッセージの整理対応) ADD START
  public neMessage: string;
  // ST-158(業務時間外メッセージの整理対応) ADD END

  public uniqueId: string;
 }



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/common-base-data.ts